<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch01-1">
<p class="centerImage"><img alt="images" id="img10" src="images/img10.jpg" style="max-width:100%;"/></p>
<p class="caption"><em class="italic">The site of Tyburn Tree on the traffic island at the junction of Edgeware Road with Bayswater and Oxford Street, close to Marble Arch. A bronze plaque, close to the bollard in the right foreground, marks the spot. </em><span class="fontS">The author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08a_Fouldeeds_ch011.vue?5f453aff